import {
  getListToolbarBulkDeleteButtonClass,
  getListToolbarPrimaryActionButtonClass,
  getListToolbarSearchInputClass,
  getListToolbarSelectAllButtonClass,
  getListToolbarSelectAllIconClass,
  getListToolbarSortToggleClass,
  getListToolbarViewModeButtonClass,
  LIST_TOOLBAR_DOWNLOAD_MENU_CLASS,
  LIST_TOOLBAR_DOWNLOAD_MENU_ITEM_CLASS,
  LIST_TOOLBAR_DOWNLOAD_TRIGGER_CLASS,
  LIST_TOOLBAR_REGISTER_MENU_CLASS,
  LIST_TOOLBAR_REGISTER_MENU_ITEM_CLASS,
} from "../common/listToolbarSharedStyles";

export const STUDENT_LIST_HEADER_TITLE_ROW_CLASS = "flex flex-col md:flex-row justify-between items-end gap-6";

export const STUDENT_LIST_HEADER_TOOLBAR_CLASS =
  "sticky top-6 z-40 bg-white/80 backdrop-blur-xl rounded-[2rem] shadow-lg border border-white/50 p-1.5 flex flex-col md:flex-row justify-between gap-2 transition-all duration-300 items-center";

export const STUDENT_LIST_HEADER_LEFT_GROUP_CLASS = "flex-1 flex flex-wrap gap-3 items-center";

export const STUDENT_LIST_HEADER_SEARCH_WRAPPER_CLASS = "relative flex-1 max-w-sm min-w-[200px]";

export const STUDENT_LIST_HEADER_SEARCH_ICON_CLASS = "absolute left-4 top-1/2 -translate-y-1/2 text-gray-400";

export const STUDENT_LIST_HEADER_SELECT_SORT_GROUP_CLASS = "flex items-center gap-2 flex-shrink-0";

export const STUDENT_LIST_HEADER_VIEW_TOGGLE_WRAP_CLASS =
  "hidden md:flex bg-white rounded-[2rem] p-[2px] border border-gray-200 shadow-sm flex-shrink-0 items-center h-11";

export const STUDENT_LIST_HEADER_RIGHT_ACTIONS_CLASS = "flex gap-2 items-center";

export const STUDENT_LIST_HEADER_DOWNLOAD_TRIGGER_CLASS = LIST_TOOLBAR_DOWNLOAD_TRIGGER_CLASS;
export const STUDENT_LIST_HEADER_DOWNLOAD_MENU_CLASS = LIST_TOOLBAR_DOWNLOAD_MENU_CLASS;
export const STUDENT_LIST_HEADER_DOWNLOAD_MENU_ITEM_CLASS = LIST_TOOLBAR_DOWNLOAD_MENU_ITEM_CLASS;
export const STUDENT_LIST_HEADER_REGISTER_MENU_CLASS = LIST_TOOLBAR_REGISTER_MENU_CLASS;
export const STUDENT_LIST_HEADER_REGISTER_MENU_ITEM_CLASS = LIST_TOOLBAR_REGISTER_MENU_ITEM_CLASS;

export function getStudentListHeaderSearchInputClass(theme) {
  return getListToolbarSearchInputClass(theme);
}

export function getStudentListHeaderSortToggleClass(sortOrder, themeTextClass) {
  return getListToolbarSortToggleClass(sortOrder, themeTextClass);
}

export function getStudentListHeaderSelectAllButtonClass(selectedIdsLength) {
  return getListToolbarSelectAllButtonClass(selectedIdsLength);
}

export function getStudentListHeaderSelectAllIconClass(selectedIdsLength) {
  return getListToolbarSelectAllIconClass(selectedIdsLength);
}

export function getStudentListHeaderViewModeButtonClass(isActive, theme) {
  return getListToolbarViewModeButtonClass(isActive, theme);
}

export function getStudentListHeaderBulkDeleteButtonClass(selectedIdsLength) {
  return getListToolbarBulkDeleteButtonClass(selectedIdsLength);
}

export function getStudentListHeaderRegisterButtonClass(themeBgClass) {
  return getListToolbarPrimaryActionButtonClass(themeBgClass);
}
